<template>
    <div id="app" v-if="ready">

        <div v-if="!isBrowserSupported" class="unsupported-block">
            <b-field v-if="!isBrowserSupported">
                <b-message type="is-danger">
                    {{ texts.browserNotSupported }}
                </b-message>
            </b-field>
        </div>

        <router-view v-else />
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'App',
    data () {
        return {
            isBrowserSupported: true,
            config: {},
            texts: {},
            ready: false
        }
    },
    mounted() {
        DetectRTC.load(() => {
            this.isBrowserSupported = this.browserSupported();
        })
        axios.get(`/static/config.json`)
            .then(res => {
                this.config = res.data;
                axios.get(`/static/texts.json`)
                    .then(res => {
                        this.texts = res.data;
                        this.ready = true;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(err => {
                console.log(err);
            });
    },
    methods: {
        browserSupported() {
            let isSupported = true;
            if (window.navigator.userAgent.indexOf('Miui') >= 0) isSupported = false;
            if (!DetectRTC.isWebRTCSupported) isSupported = false;
            return isSupported;
        },
    },
}
</script>

<style lang="scss">

html {
    overflow: auto;
}

.unsupported-block {
    position: absolute;
    margin: 0 auto;
    width: 600px;
    max-width: 95%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* Baloo font */
@font-face {
    font-family: 'Baloo Chettan 2';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Baloo Chettan 2 Regular'), local('BalooChettan2-Regular'), url('/static/fonts/baloo1.woff2') format('woff2');
    unicode-range: U+0307, U+0323, U+0964-0965, U+0D02-0D7F, U+200C-200D, U+20B9, U+25CC;
}
@font-face {
    font-family: 'Baloo Chettan 2';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Baloo Chettan 2 Regular'), local('BalooChettan2-Regular'), url('/static/fonts/baloo2.woff2') format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
@font-face {
    font-family: 'Baloo Chettan 2';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Baloo Chettan 2 Regular'), local('BalooChettan2-Regular'), url('/static/fonts/baloo3.woff2') format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
@font-face {
    font-family: 'Baloo Chettan 2';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Baloo Chettan 2 Regular'), local('BalooChettan2-Regular'), url('/static/fonts/baloo4.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* VideoRTC Font */
$videortc-icon-fast-forward: "\e920";
$videortc-icon-pause: "\e921";
$videortc-icon-play: "\e922";
$videortc-icon-play-next: "\e923";
$videortc-icon-previous-track: "\e924";
$videortc-icon-rewind: "\e925";
$videortc-icon-stop: "\e926";
$videortc-icon-Copy1: "\e91e";
$videortc-icon-Copy2: "\e91f";
$videortc-icon-Call: "\e900";
$videortc-icon-callback: "\e901";
$videortc-icon-Cobrowsing: "\e902";
$videortc-icon-Cobrowsing-No: "\e903";
$videortc-icon-Filesharing: "\e904";
$videortc-icon-Filesharing-New: "\e905";
$videortc-icon-Filesharing-No: "\e906";
$videortc-icon-Hangup: "\e907";
$videortc-icon-Keymap: "\e908";
$videortc-icon-Keymap-No: "\e909";
$videortc-icon-Livechat: "\e90a";
$videortc-icon-Livechat-New: "\e90b";
$videortc-icon-Livechat-No: "\e90c";
$videortc-icon-Lock-Close: "\e90d";
$videortc-icon-Lock-Open: "\e90e";
$videortc-icon-Logo: "\e90f";
$videortc-icon-Micro: "\e910";
$videortc-icon-Micro-No: "\e911";
$videortc-icon-Record: "\e912";
$videortc-icon-Screensharing: "\e913";
$videortc-icon-Screensharing-New: "\e914";
$videortc-icon-Screensharing-No: "\e915";
$videortc-icon-Settings: "\e916";
$videortc-icon-Sound: "\e917";
$videortc-icon-Sound-No: "\e918";
$videortc-icon-Warning: "\e919";
$videortc-icon-Watch: "\e91a";
$videortc-icon-Watch-No: "\e91b";
$videortc-icon-Webcam: "\e91c";
$videortc-icon-Webcam-No: "\e91d";
@font-face {
    font-family: 'videortc';
    src:  url('/static/fonts/videortc/videortc.eot?62frae');
    src:  url('/static/fonts/videortc/videortc.eot?62frae#iefix') format('embedded-opentype'),
    url('/static/fonts/videortc/videortc.ttf?62frae') format('truetype'),
    url('/static/fonts/videortc/videortc.woff?62frae') format('woff'),
    url('/static/fonts/videortc/videortc.svg?62frae#videortc') format('svg');
    font-weight: normal;
    font-style: normal;
}
[class^="videortc-icon"], [class*=" videortc-icon"] {
    font-family: 'videortc' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.videortc-icon-fast-forward {
    &:before {
        content: $videortc-icon-fast-forward;
    }
}
.videortc-icon-pause {
    &:before {
        content: $videortc-icon-pause;
    }
}
.videortc-icon-play {
    &:before {
        content: $videortc-icon-play;
    }
}
.videortc-icon-play-next {
    &:before {
        content: $videortc-icon-play-next;
    }
}
.videortc-icon-previous-track {
    &:before {
        content: $videortc-icon-previous-track;
    }
}
.videortc-icon-rewind {
    &:before {
        content: $videortc-icon-rewind;
    }
}
.videortc-icon-stop {
    &:before {
        content: $videortc-icon-stop;
    }
}
.videortc-icon-Copy1 {
    &:before {
        content: $videortc-icon-Copy1;
    }
}
.videortc-icon-Copy2 {
    &:before {
        content: $videortc-icon-Copy2;
    }
}
.videortc-icon-Call {
    &:before {
        content: $videortc-icon-Call;
    }
}
.videortc-icon-callback {
    &:before {
        content: $videortc-icon-callback;
    }
}
.videortc-icon-Cobrowsing {
    &:before {
        content: $videortc-icon-Cobrowsing;
    }
}
.videortc-icon-Cobrowsing-No {
    &:before {
        content: $videortc-icon-Cobrowsing-No;
    }
}
.videortc-icon-Filesharing {
    &:before {
        content: $videortc-icon-Filesharing;
    }
}
.videortc-icon-Filesharing-New {
    &:before {
        content: $videortc-icon-Filesharing-New;
    }
}
.videortc-icon-Filesharing-No {
    &:before {
        content: $videortc-icon-Filesharing-No;
    }
}
.videortc-icon-Hangup {
    &:before {
        content: $videortc-icon-Hangup;
    }
}
.videortc-icon-Keymap {
    &:before {
        content: $videortc-icon-Keymap;
    }
}
.videortc-icon-Keymap-No {
    &:before {
        content: $videortc-icon-Keymap-No;
    }
}
.videortc-icon-Livechat {
    &:before {
        content: $videortc-icon-Livechat;
    }
}
.videortc-icon-Livechat-New {
    &:before {
        content: $videortc-icon-Livechat-New;
    }
}
.videortc-icon-Livechat-No {
    &:before {
        content: $videortc-icon-Livechat-No;
    }
}
.videortc-icon-Lock-Close {
    &:before {
        content: $videortc-icon-Lock-Close;
    }
}
.videortc-icon-Lock-Open {
    &:before {
        content: $videortc-icon-Lock-Open;
    }
}
.videortc-icon-Logo {
    &:before {
        content: $videortc-icon-Logo;
    }
}
.videortc-icon-Micro {
    &:before {
        content: $videortc-icon-Micro;
    }
}
.videortc-icon-Micro-No {
    &:before {
        content: $videortc-icon-Micro-No;
    }
}
.videortc-icon-Record {
    &:before {
        content: $videortc-icon-Record;
    }
}
.videortc-icon-Screensharing {
    &:before {
        content: $videortc-icon-Screensharing;
    }
}
.videortc-icon-Screensharing-New {
    &:before {
        content: $videortc-icon-Screensharing-New;
    }
}
.videortc-icon-Screensharing-No {
    &:before {
        content: $videortc-icon-Screensharing-No;
    }
}
.videortc-icon-Settings {
    &:before {
        content: $videortc-icon-Settings;
    }
}
.videortc-icon-Sound {
    &:before {
        content: $videortc-icon-Sound;
    }
}
.videortc-icon-Sound-No {
    &:before {
        content: $videortc-icon-Sound-No;
    }
}
.videortc-icon-Warning {
    &:before {
        content: $videortc-icon-Warning;
    }
}
.videortc-icon-Watch {
    &:before {
        content: $videortc-icon-Watch;
    }
}
.videortc-icon-Watch-No {
    &:before {
        content: $videortc-icon-Watch-No;
    }
}
.videortc-icon-Webcam {
    &:before {
        content: $videortc-icon-Webcam;
    }
}
.videortc-icon-Webcam-No {
    &:before {
        content: $videortc-icon-Webcam-No;
    }
}

#app {
    font-family: 'Baloo Chettan 2', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 20px;
}

/*.modal-card {
    max-width: 90% !important;
}*/
.modal-card.animation-content {
    max-width: 95% !important;
}

.calling-icon {
    width: 4rem !important;
    height: 4rem !important;
}

#videocall {
    background-repeat: no-repeat;
    background-size: cover;
    background: white;
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    overflow: hidden;
    margin: 0;
    #localvideo {
        position: fixed;
        bottom: 20px;
        left: 20px;
        z-index: 2;
        video {
            width: 100px;
            height: auto;
        }
    }
    #container-remote {
        height: 100%;
        width: auto;
        position: relative;
        span[id^="remote-"] {
            display: none !important;
        }
        video {
            height: 100vh;
            width: auto;
            max-width: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }
}

.no-camera-available {
    color: white;
    position: absolute !important;
}

.switch .control-label {
    padding-left: 0;
}

.has-text-primary {
    color: #2c3e50 !important;
}
.icon {
    .cog-icon {
            width: 1.5em !important;
            height: 1.5em !important;
    }
}
.control-label-confirm {
    padding-left: 10px !important;
    font-size: .9em !important;
}
.notification {
    padding: 15px;
    margin: 0px !important;
    margin-top: 10px !important;
    margin-right: 10px !important;
    background-color: #94C2ED !important;
    opacity: .75 !important;
}
.chat {
    input {
        border-bottom-left-radius: 0px;
    }
    .input:focus, .taginput .taginput-container.is-focusable:focus, .textarea:focus, .select select:focus, .is-focused.input, .taginput .is-focused.taginput-container.is-focusable, .is-focused.textarea, .select select.is-focused, .input:active, .taginput .taginput-container.is-focusable:active, .textarea:active, .select select:active, .is-active.input, .taginput .is-active.taginput-container.is-focusable, .is-active.textarea, .select select.is-active {
        border-color: #fff;
        -webkit-box-shadow: 0;
        box-shadow: 0;
    }
}

.background-enabled {
    background: url('/static/background-large.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: contain;
    @media (max-width: 767px) {
        background: url('/static/background-square.png') no-repeat center center fixed;
        background-size: 280px;
    }
}
.background-enabled-gray {
    background-color: #929292;
}

.upload, .upload-draggable {
    width: 100%;
    .section {
        padding: 1rem .5rem
    }
}

.slow-link {
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    padding-top: 45vh;
}

.join-icon {
    height: 48px !important;
    width: 48px !important;
}

.ban-icon {
    width: 3rem !important;
    height: 3rem !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue